module.exports = __webpack_public_path__ + "img/ysps.58119b15.png";